var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPaymentMethodVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.20264,
    y: 3.84766,
    width: 21,
    height: 14.3043,
    rx: 2,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.42243 13.7154H6.08965L5.09024 9.84726C5.0428 9.66933 4.94208 9.51203 4.79392 9.43789C4.42418 9.25158 4.01674 9.1033 3.57227 9.02851V8.87959H5.71926C6.01558 8.87959 6.23781 9.1033 6.27485 9.36311L6.79341 12.1533L8.12553 8.87959H9.42126L7.42243 13.7154ZM10.1621 13.7154H8.90335L9.93981 8.87959H11.1985L10.1621 13.7154ZM12.827 10.2192C12.864 9.95879 13.0862 9.80987 13.3455 9.80987C13.7529 9.77248 14.1968 9.84726 14.5672 10.0329L14.7894 8.99177C14.419 8.84285 14.0116 8.76807 13.6418 8.76807C12.4202 8.76807 11.5312 9.43789 11.5312 10.3675C11.5312 11.0747 12.1609 11.4461 12.6054 11.6698C13.0862 11.8928 13.2714 12.0418 13.2344 12.2648C13.2344 12.5994 12.864 12.7483 12.4942 12.7483C12.0498 12.7483 11.6053 12.6368 11.1985 12.4505L10.9763 13.4923C11.4208 13.678 11.9016 13.7527 12.3461 13.7527C13.7159 13.7895 14.5672 13.1203 14.5672 12.1159C14.5672 10.851 12.827 10.7769 12.827 10.2192ZM18.9723 13.7154L17.9729 8.87959H16.8994C16.6771 8.87959 16.4549 9.02851 16.3808 9.25158L14.5301 13.7154H15.8259L16.0845 13.0088H17.6765L17.8247 13.7154H18.9723ZM17.0845 10.1819L17.4543 12.0044H16.4178L17.0845 10.1819Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaymentMethodVisa);
export default __webpack_public_path__ + "static/media/icon_payment_method_visa.7715e2d34c314c5947c6bf906f19252b.svg";
export { ForwardRef as ReactComponent };